<template>
  <div class="form-container">
    <div
      v-if="permissionFilter.includes(profile.roles.name)"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="filter">
        <b-row>
          <b-col>
            <b-form-group
              label="Company"
              label-size="sm"
              content-cols-sm="8"
              label-for="input-horizontal"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="company"
                :options="companyOptions"
                placeholder="Select Company"
                value-field="id"
                text-field="name"
                size="sm"
                @change="$refs.otherTable.refresh()"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                  >
                    All Company
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <filters
      :filter-data.sync="filters"
      :options="contractorOptions"
      @apply="$refs.otherTable.refresh()"
      @reset="resetFilter"
    />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <b-button
        v-if="canAdd"
        class="btn-custom"
        variant="info"
        size="sm"
        to="/bup-other/create"
      >
        Add Other
      </b-button>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.otherTable.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      thead-class="table-list-header"
      empty-text="No data"
      ref="otherTable"
      :items="fetchOther"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:cell(actions)="items">
        <b-dropdown
          v-if="items.item.status != 'Submitted'"
          toggle-class="text-dark p-0"
          menu-class="shadow border-0"
          variant="link"
          right
          no-caret
        >
          <template v-slot:button-content>
            <fa-icon
              class="text-info"
              icon="ellipsis-v"
            />
          </template>
          <b-dropdown-item
            v-if="items.item.status != 'Submitted' && canEdit"
            @click="goEdit(items.item)"
          >
            Edit
          </b-dropdown-item>
          <b-dropdown-item
            v-if="items.item.status != 'Submitted' && canDelete"
            variant="danger"
            @click="removeOther(items.item)"
          >
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template #cell()="{ value, item }">
        <a
          class="d-block h-100 text-dark"
          :href="`/bup-other/${item.id}/detail`"
        >
          {{ value }}
        </a>
      </template>
      <template #cell(periode)="{ item }">
        <a
          class="d-block text-dark"
          :href="`/bup-other/${item.id}/detail`"
        >
          {{ moment(new Date(`${item.periode_month}/01/${item.periode_year}`)).format('MMMM-YYYY') }}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">
          {{ items.item.status }}
        </div>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
    <modal-successful :message="text" />
    <modal-delete @click="deleteCommit" :form="other" :message="text" />
  </div>
</template>

<script>
import api from '@/api'
import Filters from './Filter'
import ModalDelete from '@/partials/ModalDelete'
import ModalSuccessful from '@/partials/ModalSuccessful'
import { hasPermission } from '@/utils/permissions'
import { OTHER_EDIT, OTHER_ADD, OTHER_DELETE } from '@/fixtures'

export default {
  components: {
    Filters,
    ModalDelete,
    ModalSuccessful
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    canAdd: hasPermission(OTHER_ADD),
    canEdit: hasPermission(OTHER_EDIT),
    canDelete: hasPermission(OTHER_DELETE),
    isBusy: false,
    search: '',
    text: '',
    currentPage: localStorage.getItem('currentPage') ?? 1,
    perPage: 10,
    totalRows: localStorage.getItem('totalRows') ?? 0,
    sortBy: 'periode_month',
    sortDesc: true,
    fields: [
      { key: 'actions', sortable: false, tdClass: 'text-center', thClass: 'start', thStyle: 'width:50px' },
      { key: 'periode', label: 'Period', sortable: true },
      { key: 'company_name', label: 'Company Name', sortable: true },
      { key: 'contractor_name', label: 'Contractor', sortable: true },
      { key: 'contract_number', label: 'Contract Number', sortable: true },
      { key: 'status', label: 'Status', sortable: true, thClass: 'end' }
    ],
    items: [],
    other: {},
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    filters: !localStorage.getItem('filterOther') ? {
      contractor_name: '',
      periode: ''
    } : JSON.parse(localStorage.getItem('filterOther')),
    company: null,
    companyOptions: [],
    contractorOptions: [],
    permissionFilter: [
      'Super Admin',
      'Finance Jakarta',
      'Administrator'
    ]
  }),

  computed: {
    stringifiedFilters() {
      const str = Object.entries(this.filters).filter(v => v[1]).map(v => {
        if (v[0] !== 'periode') {
          return v.join(':')
        } else {
          if (v[1][1]) return `${v[0]}:${v[1].join(';')}`
        }
      }).join()
      return str
    }
  },

  mounted() {
    this.fetchCompany()
    this.fetchContractorOption()
  },

  methods: {
    async fetchOther() {
      const data = await api.other.list({
        sort_by: this.sortBy,
        sort_dir: this.sortDesc ? 'DESC' : 'ASC',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        filter_value: this.stringifiedFilters,
        company_id: this.company
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []

      localStorage.removeItem('currentPage', this.currentPage)
      localStorage.removeItem('totalRows', this.totalRows)

      localStorage.setItem('filterOther', JSON.stringify(this.filters))

      return this.items
    },
    resetFilter() {
      this.filters = {
        periode: '',
        contractor_id: ''
      }
      this.currentPage = 1
      localStorage.removeItem('filterOther')
      this.$refs.otherTable.refresh()
    },
    async fetchCompany() {
      try {
        this.companyOptions = await api.company.list_active()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    async fetchContractorOption() {
      try {
        const data = await api.contractor.list()
        this.contractorOptions = data
      } catch (error) {}
    },
    goDetail(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      this.$router.push({ path: `/bup-other/${item.id}/detail` })
    },
    goEdit(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      this.$router.push({ path: `/bup-other/${item.id}/edit` })
    },
    removeOther(item) {
      this.other = item
      this.text = 'Other'
      this.$bvModal.show('modal-delete')
    },
    async deleteCommit(data) {
      try {
        await api.other.remove(data.id)
        this.text = 'delete other'
        this.$bvModal.show('modal-successful')
        this.$refs.otherTable.refresh()
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`Error ${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    statusChange(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Submitted') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
</style>
